// ** internal, non-publicly exported constants. **
export var FlowDirection = {
  BACK: 'back',
  NONE: 'none',
  FORWARD: 'forward'
}; // Requests that are blocked by the Anti-Fraud Service return a 454 status and `decision` (reason)

export var AntiFraudDecision = {
  REQUIRES_PHONE_VERIFICATION: 'REQUIRES_PHONE_VERIFICATION',
  DENY: 'DENY'
};
export var AppleAuthErrors = {
  POPUP_CLOSED_BY_USER: 'POPUP_CLOSED_BY_USER',
  CROSS_ORIGIN_POST_MESSAGE: 'CROSS_ORIGIN_POST_MESSAGE',
  STATE_PARAM_MISMATCH: 'STATE_PARAM_MISMATCH'
};
export var GoogleAuthErrors = {
  POPUP_CLOSED_BY_USER: 'popup_closed_by_user' // 'popup_closed_by_user' comes from google api's `authInstance.signIn()` on web.

};